import React from 'react'
import { useNetwork } from './hooks/useNetwork'
import './styles.css'

export default function OfflineIndicator() {
  const isOnline = useNetwork();

  return !isOnline && <div id="offline_message">Você está offline</div>;
}
